import { createFileRoute } from '@tanstack/react-router'
import { CreditUsagePage } from '@/features/account/pages/credits/credit-usage-page'

/** D4 — Usage / consumption. */
export const Route = createFileRoute('/_ws/w/$workspaceId/credits/usage')({
  component: CreditUsagePage,
})
